import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint "react/prop-types": "warn" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconBankLine } from '@instructure/ui-icons';
import { Button } from '@instructure/ui-buttons';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/es/format-message';
export var ItemBanksButton = /*#__PURE__*/function (_Component) {
  function ItemBanksButton() {
    _classCallCheck(this, ItemBanksButton);
    return _callSuper(this, ItemBanksButton, arguments);
  }
  _inherits(ItemBanksButton, _Component);
  return _createClass(ItemBanksButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Button, {
        "data-automation": "sdk-item-banks-button",
        onClick: this.props.onClick,
        ref: this.props.instUiButtonRef,
        color: "primary-inverse",
        renderIcon: IconBankLine
      }, /*#__PURE__*/React.createElement(AccessibleContent, {
        alt: t('Add from item bank')
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small"
      }, t('Item Banks'))));
    }
  }]);
}(Component);
_defineProperty(ItemBanksButton, "propTypes", {
  instUiButtonRef: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
});
export default ItemBanksButton;